"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var meta_field_model_1 = require("../controls/editor/model/meta-field.model");
var nonSimpleMetaFieldTypes = [
    idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY,
    idm_kb_service_client_js_1.MetaFieldType.PARENT
];
var identityMetaFieldTypes = [
    idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY,
    idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE
];
function getComboBoxItems(metaFields) {
    return metaFields.map(function (metaField) {
        var systemName = metaField.getSystemName();
        return new meta_field_model_1.MetaFieldModel(metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ? systemName + ".name" : systemName, systemName, metaField.getCompoundCategorySystemName(), metaField.getDisplayNameMultilingual() || metaField.getDisplayNameMsgId(), metaField.getType());
    });
}
exports.getComboBoxItems = getComboBoxItems;
function isSimpleField(metaField) {
    var metaFieldType = metaField.getType();
    return nonSimpleMetaFieldTypes.findIndex(function (type) { return type === metaFieldType; }) < 0;
}
exports.isSimpleField = isSimpleField;
function isIdentityField(metaField) {
    var metaFieldType = metaField.getType();
    return identityMetaFieldTypes.findIndex(function (type) { return type === metaFieldType; }) < 0;
}
exports.isIdentityField = isIdentityField;
function isFunctionalField(metaField) {
    var metaFieldType = metaField.getType();
    return metaFieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY;
}
exports.isFunctionalField = isFunctionalField;
function createComboBoxOptionsGroup(metaFields, subEntityName) {
    return new idm_ng_controls_1.ComboboxGroup(metaFields.map(function (metaField) {
        var systemName = metaField.getSystemName();
        return new idm_ng_controls_1.ComboboxOption({
            id: systemName,
            bindingName: metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ? systemName + '.name' : systemName
        }, metaField.getDisplayNameMultilingual() || metaField.getDisplayNameMsgId() || systemName);
    }), subEntityName);
}
exports.createComboBoxOptionsGroup = createComboBoxOptionsGroup;
//# sourceMappingURL=meta-field-utils.js.map